import { posthog } from '@/lib/posthog'

import packageJson from '../../package-lock.json'

/**
 * This composable is used to send metric events to the server.
 *
 * @returns An object with the sendEvent function.
 */
export const useMetricEvents = () => {
  const getDefaultData = () => ({
    timestamp: Date.now(),
    url: window.location.href,
    // Platform
    platform: {
      name: 'EverGPT',
      version: packageJson.version,
    },
  })

  const sendEvent = (name: string, payload = {}) => {
    posthog.capture(name, {
      ...getDefaultData(),
      ...payload,
    })
  }

  return {
    sendEvent,
  }
}
